import { useQuery, keepPreviousData } from '@tanstack/react-query'
import api from '@/services/api'
import type {
  FrontendLogsResponse,
  LogLevel,
  LogCategory,
} from '@/types/frontendLog'

export interface FrontendLogsParams {
  fork_id?: string
  site_id?: string
  level?: LogLevel
  category?: LogCategory | string
  action?: string
  search?: string
  start_time?: string
  end_time?: string
  page?: number
  limit?: number
}

// 30分バケットを横断してログを取得
export function useFrontendLogs(
  params: FrontendLogsParams = {},
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ['logs', params],
    queryFn: async () => {
      const { data } = await api.get<FrontendLogsResponse>('/logs', {
        params,
      })
      return data
    },
    enabled: options?.enabled,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60, // 1分
    refetchOnWindowFocus: false,
    retry: 1, // エラー時のリトライ回数を制限
  })
}
